module.exports = __webpack_public_path__ + "img/ml5.282bc823.jpg";